import styled from 'styled-components';
import { TooltipWithTitle } from '@salecycle/experimental/TooltipWithTitle';
import { Icon } from '@salecycle/ui-component-library';
import { PropsWithChildren } from 'react';

const Header = styled.h3`
  display: flex;
  align-items: center;

  margin-bottom: ${({ theme }) => theme.designToken.spacing3};

  & .sidebar-icon {
    color: ${({ theme }) => theme.vars.newColor.darkGS2};
  }
`;

export interface WorkflowSidebarProps {
  header: string;
  tooltip: string;
}

export const WorkflowSidebar = ({ header, tooltip, children }: PropsWithChildren<WorkflowSidebarProps>) => {
  return (
    <>
      <Header>
        <span style={{ marginRight: '1rem' }}>{header} </span>
        <TooltipWithTitle content={tooltip}>
          <Icon className="sidebar-icon" icon="question-circle" />
        </TooltipWithTitle>
      </Header>
      {children}
    </>
  );
};
